<label *ngIf="label" class="global-form-field mb-2">
  {{ label }}
  <span *ngIf="isRequired" class="text-danger fw-bold">*</span>
</label>
<ng-container *ngIf="!skeletonLoading; else skeleton">
  <!-- 1. Wrap everything in a main flex container -->
  <div class="d-flex align-items-start gap-3 w-100">
    
    <!-- Old/New Dropdown -->
    <app-select
      style="flex: 0 0 85px;" 
      [(ngModel)]="ppaNumber.PPAOldOrNew"
      [options]="oldNewDropdown"
      (selectionChange)="oldNewChange()"
      [disabled]="disabled"
      #oldNewInput="ngModel"
    />

    <!-- 2. The child container expands to fill the remaining horizontal space -->
    <div class="flex-grow-1">
      @if(isFormatBox){
        <!-- Added d-flex and gap utilities for the inner fields -->
        <div class="layout d-flex align-items-center gap-2">
          <app-select
            style="flex: 1 1 70px"
            [(ngModel)]="ppaNumber.DataFileld1"
            [options]="temporaryPrefixPoliceAndAffair"
            (change)="updateField()"
            [disabled]="disableField(ppaNumber.PPAOldOrNew)"
            #dField1Input="ngModel"
          />
          <app-select
            style="flex: 1 1 70px"
            [(ngModel)]="ppaNumber.DataFileld2"
            [options]="originalDivisionCodes"
            (change)="updateField()"
            [disabled]="disableField(ppaNumber.DataFileld1)"
            #dField2Input="ngModel"
          />
          <app-input
            style="flex: 1 1 100px"
            [placeholder]="'------'"
            [maxlength]="6"
            [minlength]="4"
            [validateNumber]="true"
            [(ngModel)]="ppaNumber.DataFileld3"
            (input)="updateField()"
            [disabled]="disableField(ppaNumber.DataFileld2)"
            #dField3Input="ngModel"
          />

          <div class="d-flex align-items-center gap-2">
            <app-input
              style="flex: 0 0 75px;"
              [placeholder]="'----'"
              [maxlength]="4"
              [minlength]="4"
              [validateNumber]="true"
              [(ngModel)]="ppaNumber.DataFileld4"
              (ngModelChange)="setValueDataField5($event)"
              (input)="updateField()"
              [disabled]="disableField(ppaNumber.DataFileld3)"
              #dField4Input="ngModel"
            />
            <span class="text-muted">-</span>
            <app-input
              style="flex: 0 0 75px;"
              [placeholder]="'----'"
              [maxlength]="6"
              [minlength]="3"
              [(ngModel)]="ppaNumber.DataFileld5"
              (input)="updateField()"
              [disabled]="true"
              #dField5Input="ngModel"
            />
          </div>
        </div>
      } @else {
        <!-- Fallback Input takes full remaining width -->
        <app-input
          class="w-100"
          [(ngModel)]="ppaNumber.PPANumber"
          [disabled]="disabled"
          (input)="updateField()"
          #pensionerPPANoInput="ngModel"
        />
      }
    </div>

  </div>
</ng-container>
<div class="error" *ngIf="shouldShowError">This field is required</div>

<ng-template #skeleton>
  <!-- <ngx-skeleton-loader
      count="1"
      [theme]="{ 'border-radius': '4px', height: '42px', 'flex': '1 0 70px', 'max-width': '85px' }"
    /> -->
  <div class="d-flex align-items-center gap-2">
    <ngx-skeleton-loader
      count="1"
      style="width: 100%"
      [theme]="{margin: 0, 'border-radius': '4px',  height: '42px',}"
    />
    <ngx-skeleton-loader
      count="1"
      style="width: 100%"
      [theme]="{ margin: 0, 'border-radius': '4px', height: '42px' }"
    />
    <ngx-skeleton-loader
      count="1"
      style="width: 100%"
      [theme]="{ margin: 0, 'border-radius': '4px', height: '42px' }"
    />
    <ngx-skeleton-loader
      count="1"
      style="width: 100%"
      [theme]="{ margin: 0, 'border-radius': '4px', height: '42px' }"
    />

    <div class="d-flex align-items-center gap-2 w-100">
      <ngx-skeleton-loader
        count="1"
        style="width: 100%"
        [theme]="{ margin: 0, 'border-radius': '4px', height: '42px' }"
      />
      -
      <ngx-skeleton-loader
        count="1"
        style="width: 100%"
        [theme]="{ margin: 0, 'border-radius': '4px', height: '42px' }"
      />
    </div>
  </div>
</ng-template>
